import i18n from 'i18next'
import {initReactI18next} from 'react-i18next'

// @ts-ignore
import en from './generated/locales/base.json'
// @ts-ignore
import jp from './generated/locales/jp.json'

export const resources = {
    'ja-JP': {
        translation: jp
    },
    'en-US': {
        translation: en
    }
}

const supportedLngs = ['ja-JP', 'en-US'] as const
export const LANG_STORAGE_KEY = 'lang'
const detectLanguage = (): string => {
    const stored = localStorage.getItem(LANG_STORAGE_KEY)
    if (stored && (supportedLngs as readonly string[]).includes(stored)) return stored
    const browserLang = navigator.language || navigator.languages?.[0] || ''
    if (browserLang.startsWith('ja')) return 'ja-JP'
    const match = supportedLngs.find(l => browserLang.startsWith(l.split('-')[0]))
    return match ?? 'en-US'
}

i18n.use(initReactI18next).init({
    resources,
    lng: detectLanguage(),
    fallbackLng: 'en-US',
    interpolation: {
        escapeValue: false
    }
})

i18n.on('languageChanged', lng => localStorage.setItem(LANG_STORAGE_KEY, lng))

i18n.services.formatter?.add('LOCAL_DATETIME', (dt, lng) =>
    dt.toLocaleString(lng, {year: 'numeric', month: 'long', day: 'numeric'})
)
i18n.services.formatter?.add('LOCAL_DATE_SHORT', (dt, lng) =>
    new Intl.DateTimeFormat(lng, {
        month: 'long',
        day: 'numeric',
        weekday: 'short'
    }).format(dt)
)

i18n.services.formatter?.add('LOCAL_MONTH', (dt, lng) =>
    new Intl.DateTimeFormat(lng, {
        month: 'long',
        year: 'numeric',
    }).format(dt)
)

i18n.services.formatter?.add('LOCAL_DATE', (dt, lng) =>
    new Intl.DateTimeFormat(lng, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    }).format(dt)
)

i18n.services.formatter?.add('LOCAL_DAY', (dt, lng) =>
    new Intl.DateTimeFormat(lng, {
        day: 'numeric',
    }).format(dt)
)
export default i18n
